/**
 * A Base class for capturing a region of interest from user input.
 */
export class RoiHandlerBase {
  constructor (eventChannel, viewport, settings) {
    this.settings = Object.assign({
      viewportInfo: viewport.getVPView()
    }, settings);
    this.eventChannel = eventChannel;
  }

  signalUserActionComplete (drawing) {
    this.eventChannel.trigger('drawing:user-action-complete', drawing);
  }

  finish (drawing, zoom) {
    this.eventChannel.trigger('drawing:complete', drawing, zoom || this.settings.viewportInfo.zoom);
  }

  /**
     * Normalize the rectangle's coordinate system to the viewport's.
     * @param rectangle
     * @param viewportInfo
     */
  static normalizeAndOffset (rectangle, viewportInfo) {
    const vpOffset = {
      x: viewportInfo.left / viewportInfo.zoom,
      y: viewportInfo.top / viewportInfo.zoom
    };
    rectangle
      .offset(vpOffset.x, vpOffset.y)
      .normalize();
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/drawing/RoiHandlerBase.js